import { render } from "./IconDown.vue?vue&type=template&id=46921567"
import script from "./IconDown.vue?vue&type=script&lang=js"
export * from "./IconDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__